function UsersMainViewController(
  userViewService,
  accountService,
  eventService,
  $interval
) {
  const ctrl = this;
  ctrl.$onInit = () => {
    userViewService.setView('users');
    ctrl.getUserGroups();
    ctrl.startPoll();
  };

  ctrl.$onDestroy = () => {
    $interval.cancel(ctrl.dataFetchPromise);
    listener();
  };

  const listener = eventService.on('accounts.update', () => {
    ctrl.update();
  });

  ctrl.startPoll = () => {
    ctrl.lastDataLoad = DateTime.now();
    ctrl.dataFetchPromise = $interval(ctrl.triggerDataLoad, 10000);
  };

  ctrl.triggerDataLoad = () => {
    if (ctrl.lastDataLoad.diffNow('seconds').seconds < -9) {
      ctrl.update();
    }
  };

  ctrl.getUserGroups = () => {
    accountService.getGroups().then(data => ctrl.userGroups = data);
  };

  ctrl.update = function() {
    accountService.getAll().then(data => {
      if (!angular.equals(ctrl.data, data)) {
        ctrl.allAccounts = data;
      }
      data = null;
    });
  };
}

angular
  .module('users.module')
  .controller('UsersMainViewController', UsersMainViewController);
